import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, fluidTypeScale } = useTheme();
  return {
    cards: css`
      margin-right: 20px;
      border-radius: 8px;
      ${breakpoints.l} {
        :nth-of-type(2) {
          margin-top: 3.5rem;
        }
      }
    `,
    innerContainer: css`
      margin-bottom: 3rem;
    `,
    card: css`
      border-radius: 8px;
      grid-auto-rows: 8.3rem;
    `,
    header: css`
      text-transform: uppercase;
      color: ${colors.red};
      font-size: ${fluidTypeScale.font12_12};
      line-height: 16px;
      margin-bottom: 10px;
      cursor: pointer;
      letter-spacing: 0.12em;

      ${breakpoints.l} {
        text-align: left;
        font-size: ${fluidTypeScale.font12_12};
        line-height: 16px;
        margin-bottom: 10px;
        font-weight: 700;
      }
    `,
    description: isExpanded => css`
      color: ${colors.navy};
      font-size: ${fluidTypeScale.font18_18};
      line-height: 24px;
      letter-spacing: 0.0027em;
      height: 120px;

      ${isExpanded === true &&
      css`
        height: auto;
      `}
      ${breakpoints.l} {
        font-size: ${fluidTypeScale.font18_18};
        line-height: 24px;
      }
      ${breakpoints.xxl} {
        font-size: ${fluidTypeScale.font18_18};
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.0027em;
        text-align: left;
        height: 120px;
      }
      @media screen and (min-width: 1212px){
        ${isExpanded === true &&
        css`
          height: auto;
        `}
      }
    `,
    learnMore: css`
      display: flex;
      align-items: center;
      padding: 15px 0px 8px 0px;
      border-top: 1px solid ${colors.lightGrey};
      margin-top: 9px;
      &:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.navy};
        cursor: pointer;
      }
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        outline: none;
        border-bottom: 2px solid ${colors.border_black};
        padding-right: 1rem;
        &:hover {
          text-decoration: underline;
          text-decoration-color: ${colors.black};
        }
        p {
          margin-bottom: 0;
        }
        p span {
          color: ${colors.border_black};
        }
        span {
          color: ${colors.border_black};
        }
        img {
          filter: grayscale(1) brightness(0) invert(0);
        }
      }
      ${breakpoints.mm_s_m} {
        margin-top: 1.5rem;
      }
      ${breakpoints.mm_m_l} {
        margin-top: 2rem;
      }
      ${breakpoints.mm_l_xl} {
        margin-top: 2rem;
      }

      ${breakpoints.l} {
        display: flex;
      }
    `,
    imgSection: ({ desktop, mobile }) => css`
      width: 100%;
      height: 195px;
      border-radius: 8px 8px 0 0;
      background: url(${mobile.src}) 0 0 no-repeat;
      background-size: cover;
      position: relative;
      cursor: pointer;
      margin-left: 1px !important;

      ${breakpoints.l} {
        background: url(${desktop.src}) 0 0 no-repeat;
        background-size: cover;
      }
      &:focus-visible {
        outline: none;
        .youtube {
          border: 2px solid ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }

      .youtube {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        &:hover {
          filter: brightness(77%);
        }
      }
    `,
    cardalign: isExpanded => css`
      background-color: ${colors.white};
      padding: 32px 24px 15px 24px;
      // height: 280px;
      ${isExpanded === true &&
      css`
        height: auto;
      `}
    `,
    learnmore: css`
      font-size: ${fluidTypeScale.font15_15};
      letter-spacing: 0.12em;
      text-align: left;
      line-height: 16px;
      width: 222px;
      color: ${colors.navy};
      text-transform: uppercase;
      font-weight: 700;
    `,
    learnmoreArrow: css`
      margin-left: auto;
    `,
    quickLinkContainer: css`
      display: inline-flex;
      height: 100%;
      background-color: ${colors.white};
      padding-top: 5px;
    `,
    boldData: css`
      font-weight: 700;
      padding-right: 3px;
    `,
    expand: css`
      display: flex;
      inline: block;
    `,
    descriptionLink: css`
      &:hover {
        font-weight: bold;
        cursor: pointer;
      }
    `,
    showMore: css`
      color: ${colors.next_grey};
      cursor: pointer;
      font-weight: 700;
      text-decoration: none;
      display: inline-block;
      &:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.next_grey};
        cursor: pointer;
      }
      &:active {
        text-decoration: underline;
        text-decoration-color: ${colors.next_grey};
      }
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        outline: none;
        color: ${colors.border_black};
        border-bottom: 2px solid ${colors.border_black};
        span img {
          filter: grayscale(1) brightness(0) invert(0);
        }
      }

      ${breakpoints.l} {
        &:hover {
          text-decoration: underline;
        }
      }
    `,
    expandArrow: css`
      display: inline-block;
      margin-left: 5px;
      vertical-align: middle;
    `,
  };
};
